import { getMarketOverviewBreadcrumbsRoute } from '@/creditflowresearch/ui/common/helpers';

const getParentBreadcrumbs = (filters, parentName: string) => ([
  getMarketOverviewBreadcrumbsRoute(filters, true),
  {
    title: parentName,
    isActive: true,
  },
]);

export default getParentBreadcrumbs;
